module.exports = __webpack_public_path__ + "015e8316bc22ccf531b5f53b0ffde438.svg";